import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import { authReducer, forgetPasswordReducer, resetPasswordReducer, resendVerificationReducer } from "./features/auth/authSlice";
import { userReducer, userCommonReducer } from "./features/users/userSlice";
import { addChatReducer, addMessageReducer, chatCommonReducer, getChatsListReducer, getMessagesListReducer } from "./features/chats/chatSlices";
import { appVersionReducer, languageReducer, updateAppVersionReducer } from "./features/settings/settingSlice";
import { createPropertySlice, deletePropertySlice, properties } from "./features/properties/propertySlice";
import { deleteNotificationSlice, notifications } from "./features/notifications/notificationSlice";
import { dashboardReducer } from "./features/dashboard/dashboardSlice";
import { barcodeReducer } from "./features/barcode/barcodeSlice";
import { orderStatusReducer } from "./features/orderStatus/orderStatusSlice";
import { createDeviceSlice, deleteDeviceSlice, deviceReducer } from "./features/device/deviceSlice";
import { inventoryReducer } from "./features/inventory/inventorySlice";
import { shopifyOrderReducer } from "./features/shopifyOrders/shopifyOrdersSlice";
import { analyticsReducer } from "./features/Analytics/analyticsSlice";
import { profileDetails } from "./features/profile/profileSlice";
import { integrationReducer } from "./features/integration/integrationSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    forgetPasswordSlice: forgetPasswordReducer,
    resetPasswordSlice: resetPasswordReducer,
    resendVerificationSlice: resendVerificationReducer,
    userSlice: userReducer,
    userCommonSlice: userCommonReducer,
    addChatSlice: addChatReducer,
    chatCommonSlice: chatCommonReducer,
    getChatsListSlice:getChatsListReducer,
    addMessageSlice: addMessageReducer,
    getMessagesListSlice:getMessagesListReducer,
    languageSlice: languageReducer,
    appVersionReducer:appVersionReducer,
    updateAppVersionSlice:updateAppVersionReducer,
    propertiesSlice: properties,
    deletePropertySlice: deletePropertySlice,
    createPropertySlice: createPropertySlice,
    notificationsSlice: notifications,
    deleteNotificationSlice: deleteNotificationSlice,
    dashboardSlice: dashboardReducer,
    barcodeSlice: barcodeReducer,
    orderStatusSlice: orderStatusReducer,
    deviceSlice: deviceReducer,
    deleteDeviceSlice: deleteDeviceSlice,
    createDeviceSlice: createDeviceSlice,
    inventorySlice: inventoryReducer,
    shopifyOrderSlice: shopifyOrderReducer,
    analyticsSlice: analyticsReducer,
    profileDetailsSlice: profileDetails,
    integrationSlice: integrationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }).concat(logger as any),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

